
















































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { List, Sticky, Popup } from 'vant';
import SearchBar from '../components/SearchBar.vue';
import ListItem from '../components/ListItem.vue';
import FlipCountdown from 'vue2-flip-countdown';
import { getList, getAllData } from '../api';

Vue.use(List)
  .use(Sticky)
  .use(Popup);

@Component({
  components: {
    SearchBar,
    ListItem,
    FlipCountdown,
  },
})
export default class Home extends Vue {
  isInto: boolean = true;
  userNum: number = 0;
  intimes: number = 0;
  allvotes: number = 0;
  show: boolean = true;
  keyword = '';
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  page = 1;
  searchTimer: any = null;
  list: any[] = [];
  baseInfo: any = {};
  value: string = '';
  canvote: boolean = true;
  inway: number = 1;
  notictext: string = '投票已结束';
  endtimestr: string = '2023-07-01 18:00:00';
  // timelist: any = {
  //   //活动时间
  //   ysstr: 1688598000000, //2023-07-06 07:00:00
  //   // ysend: 1689004800000, //2023-07-11 00:00:00
  //   ysend: 1689177600000, //2023-07-13 00:00:00
  //   csstr: 1689350400000, //2023-07-15 00:00:00
  //   csend: 1691164800000, //2023-08-05 00:00:00
  //   jsstr: 1692460800000, //2023-08-20 00:00:00
  //   jsend: 1692979200000, //2023-08-26 00:00:00
  // };
  timelist: any = {
    //活动时间
    ysstr: 1688598000000, //2023-07-06 07:00:00
    ysend: 1689177600000, //2023-07-13 00:00:00
    csstr: 1690214400000, //2023-07-25 00:00:00
    csend: 1691078400000, //2023-08-04 00:00:00
    jsstr: 1691510400000, //2023-08-09 00:00:00
    jsend: 1692633600000, //2023-08-22 00:00:00
  };
  // votetimelist: any = {
  //   //投票时间
  //   voteysstr: 1688598000000, //2023-07-06 07:00:00
  //   // voteysend: 1689156000000, //2023-07-12 18:00:00
  //   voteysend: 1689177600000, //2023-07-13 00:00:00
  //   votecsstr: 1691078400000, //2023-08-04 00:00:00
  //   votecsend: 1691661600000, //2023-08-10 18:00:00
  //   votejsstr: 1693065600000, //2023-08-27 00:00:00
  //   votejsend: 1693389600000, //2023-08-30 18:00:00
  // };
  votetimelist: any = {
    //投票时间
    voteysstr: 1688598000000, //2023-07-06 07:00:00
    // voteysend: 1689156000000, //2023-07-12 18:00:00
    voteysend: 1689177600000, //2023-07-13 00:00:00
    votecsstr: 1690214400000, //2023-07-25 00:00:00
    votecsend: 1691337600000, //2023-08-07 00:00:00
    votejsstr: 1691510400000, //2023-08-09 00:00:00
    votejsend: 1692720000000, //2023-08-23 00:00:00
  };
  //  showtimelist: any = {
  //   //展示时间
  //   showysstr: 1688598000000, //2023-07-06 07:00:00
  //   showysend: 1691078400000, //2023-08-04 00:00:00
  //   showcsstr: 1691078400000, //2023-08-04 00:00:00
  //   showcsend: 1693065600000, //2023-08-27 00:00:00
  //   showjsstr: 1693065600000, //2023-08-27 00:00:00
  //   showjsend: 1693389600000, //2023-08-30 18:00:00
  // };
  showtimelist: any = {
    //展示时间
    showysstr: 1688598000000, //2023-07-06 07:00:00
    showysend: 1690214400000, //2023-07-25 00:00:00
    showcsstr: 1690214400000, //2023-07-25 00:00:00
    showcsend: 1691510400000, //2023-08-09 00:00:00
    showjsstr: 1691510400000, //2023-08-09 00:00:00
    showjsend: 1696089600000, //2023-10-01 00:00:00
  };

  get finishedText() {
    let text = '没有更多了~';
    if (this.keyword && !this.list.length) {
      text = '暂无相关数据';
    }
    return text;
  }
  handleLabel() {
    return { days: '天', hours: '时', minutes: '分', seconds: '秒' };
  }
  commitExam() {
    console.log('时间到了！');
  }
  mounted() {
    getAllData(this.inway).then((res: any) => {
      this.userNum = res.data.userNum;
      this.intimes = res.data.allnum;
      this.allvotes = res.data.votes;
    });
    this.getinway();
    this.getvotetime();
    this.isInto = true;
    setTimeout(() => {
      this.isInto = false;
    }, 200);
  }
  getinway() {
    const nowtime = parseInt(new Date().getTime() + '');
    console.log('nowtime:::::', nowtime);
    if (
      parseInt(this.showtimelist.showysstr) < nowtime &&
      parseInt(this.showtimelist.showysend) > nowtime
    ) {
      this.inway = 1;
    }
    if (
      parseInt(this.showtimelist.showcsstr) < nowtime &&
      parseInt(this.showtimelist.showcsend) > nowtime
    ) {
      this.inway = 2;
    }
    if (
      parseInt(this.showtimelist.showjsstr) < nowtime &&
      parseInt(this.showtimelist.showjsend) > nowtime
    ) {
      this.inway = 3;
    }
  }
  getvotetime() {
    const nowtime = parseInt(new Date().getTime() + '');
    console.log('nowtime:::::', nowtime);
    if (
      parseInt(this.votetimelist.voteysstr) < nowtime &&
      parseInt(this.votetimelist.voteysend) > nowtime
    ) {
      this.endtimestr = '2023-07-13 00:00:00';
      this.notictext = '距投票结束还有';
      this.canvote = false;
    }
    if (
      parseInt(this.votetimelist.votecsstr) < nowtime &&
      parseInt(this.votetimelist.votecsend) > nowtime
    ) {
      this.endtimestr = '2023-08-07 00:00:00';
      this.notictext = '距投票结束还有';
      this.canvote = false;
    }
    if (
      parseInt(this.votetimelist.votejsstr) < nowtime &&
      parseInt(this.votetimelist.votejsend) > nowtime
    ) {
      this.endtimestr = '2023-08-23 00:00:00';
      this.notictext = '距投票结束还有';
      this.canvote = false;
    }
  }
  goback() {
    this.$router.push('index');
  }
  async onLoad() {
    this.loading = true;
    // getList(this.page, '', this.inway + '').then((res: any) => {
    getList(this.page, '', this.inway + '').then((res: any) => {
      this.endListData(res);
    });
  }
  intoSearch() {
    this.$router.push('tovote');
  }
  endListData(ret: any) {
    this.page = this.page + 1;
    if (!ret.data || ret.data.length === 0) {
      this.finished = true;
    } else {
      this.list = [...this.list, ...ret.data];
      // this.onLoad();
    }
    this.loading = false;
  }
  resetVoteList() {
    this.list = [];
    this.finished = false;
    this.page = 1;
  }
  onClear() {
    this.resetVoteList();
    this.onLoad();
  }
}
